import request from '../utils/request';

// 创建设备
export const createDevice = (data) => {
  return request.post('/devices', data);
};

// 预生成设备ID和密码（不落库）
export const generateDevice = (deviceType) => {
  return request.get('/devices/generate', {
    params: { deviceType }
  });
};

// 获取设备列表
export const getDevices = (params) => {
  return request.get('/devices', { params });
};

// 获取设备详情
export const getDeviceDetail = (deviceId) => {
  return request.get(`/devices/${deviceId}`);
};

// 更新设备信息（管理员：全部字段）
export const updateDevice = (deviceId, data) => {
  return request.put(`/devices/${deviceId}`, data);
};

// 更新设备设置（普通用户：仅位置/阈值等）
export const updateDeviceSettings = (deviceId, data) => {
  return request.put(`/devices/${deviceId}/settings`, data);
};

// 删除设备
export const deleteDevice = (deviceId) => {
  return request.delete(`/devices/${deviceId}`);
};

// 查询设备在线状态
export const getDeviceOnlineStatus = (deviceId) => {
  return request.get('/device/online-status', {
    params: { deviceId: deviceId }
  });
};

// 获取设备在线率统计
export const getDeviceOnlineRate = (deviceId, params = {}) => {
  return request.get('/device/online-rate', {
    params: {
      deviceId: deviceId,
      ...params
    }
  });
};
